<template>
  <b-modal
    id="builder-wizard-modal"
    hide-footer
    title="Setup Wizard"
    size="xl"
  >
    <form-wizard
      finish-button-text="Save and Continue"
      :start-index.sync="activeTabIndex"
      @on-complete="onComplete"
    >
      <BuilderWizardItem
        v-for="(tab, index) in filteredTabs"
        :key="tab.title"
        :tab="tab"
        :active-tab-index="activeTabIndex"
        :index="index"
      />
    </form-wizard>
  </b-modal>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import BuilderWizardItem from '@/components/builder/BuilderWizard/BuilderWizardItem.vue'
// General
import GeneralSettings from '@/components/builder/GeneralSettings/GeneralSettings.vue'
// Fields
import FieldSettings from '@/components/builder/FieldSettings/FieldSettings.vue'
// Map
import WizardMapSettings from '@/components/builder/MapSettings/WizardMapSettings.vue'
// Popups
import PopupSettings from '@/components/builder/PopupSettings/PopupSettings.vue'
// Optional Items
import OptionalItems from '@/components/builder/BuilderWizard/OptionalItems.vue'
import SearchSettings from '@/components/builder/SearchSettings/SearchSettings.vue'
import FilterSettings from '@/components/builder/FilterSettings/FilterSettings.vue'
import SummaryTableSettings from '@/components/builder/SummaryTableSettings/SummaryTableSettings.vue'
import ComparisonGraphSettings from '@/components/builder/ComparisonGraphSettings/ComparisonGraphSettings.vue'
import FaqSettings from '@/components/builder/FaqSettings.vue'
import SplashscreenSettings from '@/components/builder/SplashScreenSettings.vue'
import DownloadSettings from '@/components/builder/DownloadSettings.vue'

const components = {
  BuilderWizardItem,
}

// eslint-disable-next-line no-use-before-define
@Component<BuilderWizard>({
  components,
  watch: {
    activeTabIndex (newValue) {
      // Problem is that vue-form-wizard resets the activeTabIndex to -1 when
      // the tabs are removed ie when modal closes
      if (newValue < 0) {
        this.activeTabIndex = 0
      }
    },
  },
})
export default class BuilderWizard extends Vue {
  activeTabIndex = 0
  tabs = [
    {
      title: 'General',
      components: [
        { component: GeneralSettings, exclude: [] },
      ],
    },
    {
      title: 'Fields',
      components: [
        { component: FieldSettings, exclude: ['accordionStyle'] },
      ],
    },
    {
      title: 'Map',
      components: [
        { component: WizardMapSettings, exclude: [] },
      ],
      mapOnly: true,
    },
    {
      title: 'Popups',
      components: [
        { component: PopupSettings, exclude: ['piechart'] },
      ],
    },
    {
      title: 'Optional Items',
      components: [
        { component: OptionalItems, exclude: [] },
        { component: SearchSettings, exclude: ['settings'] },
        { component: FilterSettings, exclude: ['settings'] },
        { component: SummaryTableSettings, exclude: ['settings'] },
        { component: ComparisonGraphSettings, exclude: ['settings'] },
        { component: FaqSettings, exclude: ['settings'] },
        { component: SplashscreenSettings, exclude: ['settings'] },
        { component: DownloadSettings, exclude: ['settings'] },
      ],
    },
  ]

  get showMap () {
    return this.$typedStore.visualisationApp.showMap
  }

  get filteredTabs () {
    return this.tabs.filter(tab => tab.mapOnly ? this.showMap : true)
  }

  onComplete () {
    this.$root.$emit('save-version')
    this.$bvModal.hide('builder-wizard-modal')
  }
}
</script>
